import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstruct from 'dojo/dom-construct';
import dojoDateLocale from 'dojo/date/locale';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './Container.html?raw';
// NOTE (JS2TS): dropped dead dojo deps (dom-attr, dom-class, dom-style) — not used. xstyle/css!./Container.css was
// already commented out in the original define(). Tabulator is a runtime global lib → declared ambiently.
declare const Tabulator: any;

class Container extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    homePanel: any = null;
    table: any = null;
    jsonData: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(bReload?: any): void {

        if (this.jsonData == null || bReload === true) {
            this.loadOccurrences();
            return;
        }

        this._renderTable();
    }

    loadOccurrences(entityID?: any): void {

        this.StandbyStart();

        var url = window.appRoot + "Occurrence/LoadOccurrenceListJSON";

        this.RequestManager.post(
            url,
            {

            },
            lang.hitch(this, "_onLoadOccurrencesResponse"),
            lang.hitch(this, "_onLoadOccurrencesError"),
            false // sync
        );
    }

    _onLoadOccurrencesResponse(response: any): void {
        this.StandbyStop();
        this.jsonData = JSON.parse(response);

        console.log("_onLoadOccurrencesResponse", this.jsonData)

        this._renderTable();
    }

    _onLoadOccurrencesError(error: any): void {
        this.StandbyStop();

        alert(error.Message);
        //this.handleErrorResponse(error.Message);
    }

    tableFormatter(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        if (data.ref_vt_property.is_value_list === true) {
            for (var i = 0; i < data.ref_vt_property.EL_vt_property_value_vt_property.length; i++) {
                var propValue = data.ref_vt_property.EL_vt_property_value_vt_property[i];

                if (propValue.ID == value) {
                    return propValue.bezeichnung;
                }
            }
        }

        return value;
    }

    tableFormatterDateTime(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        var date = new Date(value);

        console.log("tableFormatterDateTime", date, value);

        value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "HH:mm" } as any);

        return value;
    }

    //custom formatter definition
    tableBtnEdit(cell: any, formatterParams: any, onRendered: any): any { //plain text value
        return "<div class='w3-padding-small w3-center mds-bg-gray mds-hover-dark'><i class='fa fa-pencil'></i></div>";
    }

    //column definition in the columns array


    _renderTable(): void {

        domConstruct.empty(this.domNode);

        if (this.jsonData == null || typeof (this.jsonData) == "undefined") {

            return;
        }

        this.table = new Tabulator(this.domNode, {
            data: this.jsonData,
            layout: "fitColumns",
            //height: "",
            columns: [
                { title: "Nr", field: "Number", width: 90, editor: false },
                {
                    title: "Datum", field: "Time", width: 110, editor: false, formatter: this.tableFormatterDateTime
                },
                { title: "Meldender", field: "ref_reporter.DispName", editor: false },
                { title: "Meldungsart", field: "ref_occurrence_type.Name", width: 200, editor: false },
                { title: "Kostenstelle", field: "ref_cost_center2_reported.Cost_center", width: 100, editor: false },
                { title: "Meldungsstatus", field: "ref_occurrence_status.description", width: 100, editor: false },
                { title: "Rückmeldung", field: "feedback", editor: false },
                { title: "Ationen", formatter: this.tableBtnEdit, width: 50, align: "center", cellClick: this.clickTableEdit },

            ]
            //cellEdited: lang.hitch(this, "_onPropertyEdited")
        });
    }

    clickTableEdit(evt: any, cell: any): void {
        console.log("clickTableEdit", cell, cell.getRow().getData());
        var entityID = cell.getRow().getData().ID;

        this.homePanel.showOccurenceForm(entityID);
    }

}
Container.prototype.declaredClass = 'WidgetCollection.Occurrence.List.Container';

export default mdsWidget(Container);
